import { socket } from '../socket';
import colors from '../config/colors.json';
import { findMap } from '../helpers/drafting';
import { useSocketEvent, useSocketState } from '../helpers/useSocket';
import React, { useState, useEffect } from 'react';
import { VizierDisplay } from '../components/VizierDisplay';
import { WaterLevel } from '../components/WaterLevel';
import { GoldenAge } from '../components/GoldenAge';
import { Bar } from '../components/Bar100';
import 'chart.js/auto';
import { MalianCows } from '../components/MalianCows';

const isObjectEmpty = (objectName) => {
    return Object.keys(objectName).length === 0
}

export default function LiveGame() {
    const [match] = useSocketState('Match');
    const [config, setConfig] = useState({});
    const [sheepState, setSheepState] = useState({})
    const [vizierState, setVizierState] = useState({})
    const [cisternState, setCisternState] = useState({})
    const [goldenAgeState, setGoldenAgeState] = useState({})
    const [cowState, setCowState] = useState({})

    useSocketEvent('updateConfig', (newdata) => {
        console.log(`Received updateConfig`, newdata);
        setConfig(newdata)
    })

    useSocketEvent('updateSheep', (newData) => {
        setSheepState(newData)
    })

    useSocketEvent('updateVizier', (newData) => {
        setVizierState(newData)
    })

    useSocketEvent('updateCistern', (newData) => {
        setCisternState(newData)
    })

    useSocketEvent('updateGoldenAge', (newData) => {
        setGoldenAgeState(newData)
    })

    useSocketEvent('updateCow', (newData) => {
        setCowState(newData)
    })

    if (!match)
        return <div/>;

    const flipPlayers = match.flipPlayersIngame;

    const leftPlayer = !flipPlayers ? match.leftPlayer : match.rightPlayer;
    const rightPlayer = flipPlayers ? match.leftPlayer : match.rightPlayer;

    const leftColor = colors[leftPlayer.color];
    const rightColor = colors[rightPlayer.color];
    const leftScore = leftPlayer.score;
    const rightScore = rightPlayer.score;

    document.body.style.overflow = "hidden";

    const mapDetails = findMap(match.games.filter(v => v.state === 'upcoming').reverse()[0]?.map);

    return (
        <div className="livegame" style={{
            "--left-player-color": leftColor?.mainColor,
            "--left-player-color-secondary": leftColor.secondaryColor,
            "--right-player-color": rightColor?.mainColor,
            "--right-player-color-secondary": rightColor?.secondaryColor
        }}>
            <link rel="stylesheet" type="text/css" href={`/themes/${config.cssTheme}`} />

            <div className='ingameScoreWrapper'>
                <div className='scoreContainer score-leftScore'>
                    <h1>{leftScore}</h1>
                </div>
                <div className='scoreContainer score-rightScore'>
                    <h1>{rightScore}</h1>
                </div>
            </div>

            <div className='ingameScoreColor'>
				
                <div className={`scoreBannerWrapper-left`}>
					<div className="scoreBanner-img scoreBanner-left"> </div>
					<div className={`scoreBannerColorOverlay scoreBannerColorOverlay-${leftPlayer.color}-left`}></div>
				</div>
                <div className={`scoreBannerWrapper-right`}>
					<div className="scoreBanner-img scoreBanner-right"> </div>
					<div className={`scoreBannerColorOverlay scoreBannerColorOverlay-${rightPlayer.color}-right `}></div>
				</div>
                
            </div>

            <div className='minimapWrapper'>
                <div className='minimapMatchType'>{match.matchType.replace(' - ABBA', "")}</div>
                {
					mapDetails &&
					<div className='minimapMapName'>
                            {mapDetails.label}
                        </div>
                }
				<div className='minimapRoundInfo hidden'>{match.roundInfo}</div>

            </div>
        </div>
    )
}
